import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import moment from "moment";

const ServiciosUnicosDataTable = ({
    serviciosUnicos,
    loading,
    cotizacion,
    handleTablaChange,
    handleNewTramoCuota,
    handleBorrarLinea,
    handleTramoConfirmacionCuota,
    cobroOptionsServiciosUnicos,
    monedaOptions,
    showTramoModalUnico,
    setShowTramoModalUnico,
    nombreCuadro,
    cuotas,
    setCuotas,
    maxAmountOfCuotas,
    itemCuotas
    }) => {
    return (
        <>
        {serviciosUnicos.length > 0 && (
            <>
            {/* HEAD */}
            <div
                className="mt-4"
                style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                }}
            >
                <h5>TARIFA UNICA (CAPEX)</h5>
            </div>
            
            {/* BODY */}
            <DataTable 
                value={serviciosUnicos} 
                className="p-datatable-gridlines" 
                loading={loading}
                showGridlines 
                header={`Servicios Únicos`}
                emptyMessage="No seleccionó servicios"
                //rowClassName={(rowData) => rowData.isMask ? 'mask-row' : ''}
            >
                <Column
                field="es_union"
                header="Estado"
                body={(rowData) => (
                    <>
                    <div>
                        {/* {rowData.id_combo ? (
                        <Button
                            icon="pi pi-link"
                            className="p-button-rounded p-button-secondary p-button"
                            outlined
                            tooltip="Producto Combinado"
                            tooltipOptions={{ position: "top" }}
                        />
                        ) : ( */}
                        <Button
                            icon="pi pi-check"
                            className="p-button-rounded p-button-success p-button"
                            outlined
                            tooltip="Servicio Único Disponible"
                            tooltipOptions={{ position: "top" }}
                        />
                         {/* )} */}
                    </div>
                    </>
                )}
                />

                <Column 
                field="descripcion" 
                header="Nombre" 
                />

                <Column 
                field="tramo" 
                header="Cuota" 
                body={
                    (rowData) => rowData.tramo === "null" ? "" : rowData.tramo
                }
                />

                <Column
                header="Doc. Cobro"
                body={(rowData) => (
                    <Dropdown
                    value={rowData.cobro}
                    options={cobroOptionsServiciosUnicos}
                    onChange={(e) => {
                        // if (rowData.isMask) {
                        // handleMaskChange(rowData, e.value, "unicos", "cobro");
                        // } else {
                        handleTablaChange(rowData, e.value, "unicos", "cobro");
                        //}
                    }}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={rowData.cobro}
                    disabled={cotizacion?.estado.estado === "ASIGNACIÓN" || 
                        cotizacion?.estado.estado === "ANULADA" ||
                        cotizacion?.estado.estado === "RECHAZADA"}
                    />
                )}
                />

                <Column
                header="Moneda"
                body={(rowData) => {
                    const filteredOptions = monedaOptions.filter(
                    (item) => item.idEmpresa === rowData.id_empresa
                    );
                    return (
                    <Dropdown
                        value={rowData.moneda}
                        options={filteredOptions}
                        onChange={(e) => {
                        // if (rowData.isMask) {
                        //     handleMaskChange(rowData, e.value, "unicos", "moneda");
                        // } else {
                            handleTablaChange(rowData, e.value, "unicos", "moneda");
                        //}
                        }}
                        optionLabel="codigo"
                        optionValue="codigo"
                        placeholder={rowData.moneda}
                        disabled={cotizacion?.estado.estado === "ASIGNACIÓN" || 
                        cotizacion?.estado.estado === "ANULADA" ||
                        (rowData.tramo && rowData.tramo.includes("Cuota")) || 
                        cotizacion?.estado.estado === "RECHAZADA"
                        } 
                    />
                    );
                }}
                />

                <Column
                header="Tarifa Cliente"
                body={(rowData) => (
                    <InputNumber
                    value={rowData.tarifa_cliente}
                    onChange={(e) => {
                        // if (rowData.isMask) {
                        //     handleMaskChange(rowData, e.value, "unicos", "tarifa_cliente");
                        // } else {
                            handleTablaChange(
                                rowData,
                                e.value,
                                "unicos",
                                "tarifa_cliente"
                            );
                        //}
                    }}
                    locale="es-CL"
                    mode="decimal"
                    maxFractionDigits={4}
                    disabled={cotizacion?.estado.estado === "ASIGNACIÓN" ||
                        cotizacion?.estado.estado === "ANULADA" || 
                        cotizacion?.estado.estado === "RECHAZADA"}
                    />
                )}
                />

                {cotizacion?.estado.estado !== "ASIGNACIÓN" && (
                <Column
                    header="Acción"
                    style={{ minWidth: "120px" }}
                    body={(rowData) => (
                    <>
                        <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-success p-button mr-2"
                        onClick={() => handleNewTramoCuota(rowData)}
                        disabled={
                            rowData.tramo && rowData.tramo.includes("Cuota")
                        }
                        outlined
                        ></Button>
                        {rowData.tramo && rowData.tramo.includes("Cuota") && (
                        <Button
                            icon="pi pi-trash"
                            className="p-button-rounded p-button-danger p-button ml-2"
                            onClick={() => handleBorrarLinea(rowData, "unicos")}
                            outlined
                            disabled={loading ||
                            cotizacion?.estado.estado === "ANULADA" ||
                            cotizacion?.estado.estado === "ASIGNACIÓN" || 
                            cotizacion?.estado.estado === "RECHAZADA"
                            }
                        ></Button>
                        )}
                        
                        {/* SELECCION DE CUOTAS */}
                        <Dialog
                            visible={showTramoModalUnico}
                            onHide={() => {
                                setShowTramoModalUnico(false);
                            }}
                            className="p-fluid product-dialog"
                            modal
                            //k={false}
                        >
                        <div className="flex align-items-center justify-content-center text-center">
                            <div className="grid justify-content-center text-center">
                                <div className="col-12 justify-content-center text-center">
                                    <h5>
                                        Seleccione cantidad de cuotas para{" "}
                                        {nombreCuadro}
                                    </h5>
                                    <div>
                                    <InputNumber
                                        value={0}
                                        onChange={(e) => setCuotas(e.value)}
                                        locale="es-CL"
                                        maxFractionDigits={0}
                                        max={maxAmountOfCuotas}
                                    />
                                    <div className="field col-12 md:col-12">
                                        <Button
                                        icon={
                                            maxAmountOfCuotas !== 1
                                            ? "pi pi-check"
                                            : "pi pi-ban"
                                        }
                                        label={
                                            maxAmountOfCuotas !== 1
                                            ? "Confirmar"
                                            : "No puede agregar cuotas"
                                        }
                                        className="p-button-rounded p-button-success p-button mb-2 mt-2"
                                        onClick={() =>
                                            handleTramoConfirmacionCuota(itemCuotas)
                                        }
                                        disabled={
                                            1 >= cuotas ||
                                            loading ||
                                            maxAmountOfCuotas === 1
                                        }
                                        raised
                                        />
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Dialog>
                    </>
                    )}
                />
                )}
            </DataTable>
            
            {/* FOOTER */}
            <div
                className="grid ml-2 mr-2 mb-4 mt-4"
                style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                }}
            ></div>
            </>
        )}
        </>
    );
};

export default ServiciosUnicosDataTable;